module.exports = __webpack_public_path__ + "static/media/ks_testtube1.025a0ff8.svg";